import React from 'react';

const ExteriorContractorProductionVector = ({ ...props }) => (
  <svg
    width="379"
    height="376"
    viewBox="0 0 379 376"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M372.008 376H6.99156C5.13728 376 3.35894 375.263 2.04777 373.951C0.736603 372.64 0 370.86 0 369.005V189.317C6.26125e-07 188.397 0.181199 187.487 0.5332 186.637C0.885201 185.788 1.40111 185.017 2.05143 184.367L184.56 2.04505C185.871 0.73552 187.648 0 189.5 0C191.353 0 193.129 0.73552 194.44 2.04505L376.949 184.367C377.599 185.017 378.115 185.788 378.467 186.637C378.819 187.487 379 188.397 379 189.317V369.005C379 370.86 378.263 372.64 376.952 373.951C375.641 375.263 373.863 376 372.008 376Z"
      fill="#003E7D"
    />
  </svg>
);

export default ExteriorContractorProductionVector;
